
import './Teenused.css';
import {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image, Table, ThemeProvider } from 'react-bootstrap';

export default function Hero() {

    return (
      
        <div className='main'>
          <div className='teenused'>
            <Container>
              <h1 style={{marginBottom:"2.5rem"}}><strong>Teenused</strong></h1>
              <div className='teenused-grid'>
                <a href='/teenused/ortodontia' className='teenused-item'>
                  <div className='teenused-photo-adult'>
                    <h5 style={{color:"#43ACE7", textDecoration:"none", minHeight:"30px", textAlign:"center", verticalAlign:"bottom", backgroundColor:"white", margin:"0", width:"100%", borderRadius:"0 0 24px 24px"}}>
                      Täiskasvanute Ortodontia
                    </h5>
                  </div>
                </a>
                <a href='/teenused/ortodontia-teens' className='teenused-item'>
                  <div className='teenused-photo-teens'>
                    <h5 style={{color:"#43ACE7", textDecoration:"none", minHeight:"30px", textAlign:"center", verticalAlign:"bottom", backgroundColor:"white", margin:"0", width:"100%", borderRadius:"0 0 24px 24px"}}>
                      Teens Ortodontia
                    </h5>
                  </div>
                </a>
                <a href='/teenused/ortodontia-laste' className='teenused-item'>
                  <div className='teenused-photo-laste'>
                    <h5 style={{color:"#43ACE7", textDecoration:"none", minHeight:"30px", textAlign:"center", verticalAlign:"bottom", backgroundColor:"white", margin:"0", width:"100%", borderRadius:"0 0 24px 24px"}}>
                      Laste Ortodontia
                    </h5>
                  </div>
                </a>
                <a href='/teenused/esteetiline' className='teenused-item'>
                  <div className='teenused-photo-esteetiline'>
                    <h5 style={{color:"#43ACE7", textDecoration:"none", minHeight:"30px", textAlign:"center", verticalAlign:"bottom", backgroundColor:"white", margin:"0", width:"100%", borderRadius:"0 0 24px 24px"}}>
                      Esteetiline
                    </h5>
                  </div>
                </a>
                <a href='/teenused/valgendamine' className='teenused-item'>
                  <div className='teenused-photo-valgendamine'>
                    <h5 style={{color:"#43ACE7", textDecoration:"none", minHeight:"30px", textAlign:"center", verticalAlign:"bottom", backgroundColor:"white", margin:"0", width:"100%", borderRadius:"0 0 24px 24px"}}>
                      Valgendamine
                    </h5>
                  </div>
                </a>
                <a href='/teenused/puhastus' className='teenused-item'>
                  <div className='teenused-photo-puhastus'>
                    <h5 style={{color:"#43ACE7", textDecoration:"none", minHeight:"30px", textAlign:"center", verticalAlign:"bottom", backgroundColor:"white", margin:"0", width:"100%", borderRadius:"0 0 24px 24px"}}>
                      Puhastus
                    </h5>
                  </div>
                </a>
                <a href='/teenused/diagnostika' className='teenused-item'>
                  <div className='teenused-photo'>
                    <h5 style={{color:"#43ACE7", textDecoration:"none", minHeight:"30px", textAlign:"center", verticalAlign:"bottom", backgroundColor:"white", margin:"0", width:"100%", borderRadius:"0 0 24px 24px"}}>
                      Diagnostika
                    </h5>
                  </div>
                </a>
                <a href='/teenused/reteinerid' className='teenused-item'>
                  <div className='teenused-photo-retainerid'>
                    <h5 style={{color:"#43ACE7", textDecoration:"none", minHeight:"30px", textAlign:"center", verticalAlign:"bottom", backgroundColor:"white", margin:"0", width:"100%", borderRadius:"0 0 24px 24px"}}>
                      Reteinerid
                    </h5>
                  </div>
                </a>
                {
                  /* 
                <div className='teenused-item'><a className='teenused-a' href='/teenused/ortodontia'>Ortodontia</a></div>
                <div className='teenused-item'>Esteetiline hambaravi</div>
                <div className='teenused-item'>Proteesimine</div>
                <div className='teenused-item'>Diagnostika</div>
                <div className='teenused-item'>Laste hambaravi</div>
                <div className='teenused-item'>Braketi Ravi</div>
                <div className='teenused-item'>Kaperavi</div>
                <div className='teenused-item'></div>
                */
                }
              </div>
            </Container>
          </div>
          <Container>
                <hr></hr>
          </Container>
          
          <Container style={{marginBottom:"2.5rem"}}>
           <h1 style={{color:"#43ACE7"}}>
            <strong >Mis on ortodontia ja milleks see vajalik on?</strong>
          </h1>
            <p style={{color:"#43ACE7", fontWeight:"600", textAlign:"start", fontSize:"16px"}}>           
Ortodontia on hambaravi eriala, mis tegeleb hammaste ja lõualuude asendi
korrigeerimisega. Ortodontilise ravi eesmärk ei ole ainult sirgemad hambad ja kaunim
naeratus, vaid ka hästi toimiv hambumus ja suu parem tervis.
Ortodontiline ravi võib olla vajalik siis, kui hambad on viltu, hambakaared on liiga kitsad,
hambad ei mahu õigesti kaarde või ülemised ja alumised hambad ei sobitu omavahel
hästi. Sellised olukorrad võivad mõjutada nii mälumist, hammaste kulumist, suuhügieeni
kui ka enesekindlust.
Ortodontia aitab:
<ul>
  <li>
                suunata hambaid õigesse asendisse
  </li>
    <li>
      parandada hambumust ja lõualuude omavahelist suhet
  </li>
    <li>
      luua paremad tingimused hammaste puhastamiseks
  </li>
    <li>
       toetada suu tervist ja püsivamat ravitulemust
  </li>
</ul>
Ortodontiline ravi hõlmab ennetavat ravi lastel, samuti breketeid, kapesid ehk
aligner-ravi ja teisi ortodontilisi aparaate vastavalt patsiendi vajadusele.
                </p>
            </Container>

        </div>
    );
}